const Form016TC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "申請資料",
        confirmation: "確認",
    },

    importantNotesContent: {
        title: "提示",
        p1: "申請者在遞交申報表前，請準備以格式JPG,PNG或PDF的有關文件檔案:",
        p1Annotion: "(所有文件的總大小不可超過10MB)",
        p2: "申請者需透過已啟用數碼簽署功能的「智方便」帳戶，以辦理網上遞交申報表。",
        p3: "請將專業發展資料冊(附「行動研究計劃」)一式兩份連同此申請表，經由以下方法遞交：",
        p3Point1:
            "以專人遞交至香港添馬添美道2號政府總部東翼5樓教育局專業發展及培訓分部〈請在遞交日期最少2個工作天前致電3509 7471登記預約〉；",
        p3Point1BoldText: "或",
        p3Point2:
            "以掛號郵件寄交至香港添馬添美道2號政府總部東翼5樓教育局專業發展及培訓分部學校領導及專業發展組收",
        iamSignCheck: "本人理解申請人需要擁有「智方便+」帳戶才能處理申請。",
    },

    applicationInformationContent: {
        label: {
            refNo: "檔案編號：",
            refNoTxtAfterField: "（只供部門使用）",

            circularNumber: "第2/2019號",
            // refNO: "A123",
            formTitle: "個人資料",
            nameOfApplicationEn:
                "申請人姓名（須與申請人之香港身份證上所載相同）(英文)",
            nameOfApplicationCh:
                "申請人姓名（須與申請人之香港身份證上所載相同）(中文)",
            sex: "性別",
            sexOption: {
                male: "男",
                female: "女",
            },
            mailingAddress: "通訊地址（請以英文填寫）",
            schoolOrOffice: "電話號碼(學校/辦公室)",
            schoolOrOfficeOption: {
                school: "學校電話號碼",
                office: "辦公室電話號碼",
            },
            workTel: "電話號碼",
            homeOrMobile: "電話號碼(住宅/手提)",
            homeOrMobileOption: {
                home: "住宅電話號碼",
                mobile: "手提電話號碼",
            },
            privateTel: "電話號碼",
            fax: "傳真號碼",
            email: "電郵地址",
            hkidOrPassport: "香港身份證/護照",
            hkidOrPassportOption: {
                hkid: "香港身份證",
                passportNo: "護照號碼",
            },
            hkid: "香港身份證",
            passportNo: "護照號碼",
            rtOrPt: "檢定教員/准用教員",
            rtOrPtOption: {
                rtNo: "檢定教員",
                ptNo: "准用教員",
            },
            rtNo: "檢定教員編號",
            ptNo: "准用教員編號",
            schoolOrOrganisation: "申請人所屬學校/機構",
            schoolOrOrganisationOption: {
                school: "申請人所屬學校",
                organisation: "申請人所屬機構",
            },
            school: "學校",
            organisation: "機構",
            schoolName: "名稱",
            schoolAddress: "地址",
            schoolType: "學校類別（如適用）",
            schoolTypeOption: {
                primary: "小學",
                secondary: "中學",
                special: "特殊學校",
            },
            schoolTypeOption2: {
                government: "官立",
                aided: "資助",
                dss: "直資",
                others: "其他",
            },
            otherSchoolType: "其他（請說明）",
            certificationTitle: "專業資歷",
            certificationName:
                "師資培訓資歷(例如教師證書、學位教師教育文憑/證書、教育學士學位或具同等學歷)",
            awardingInstituteName: "頒發院校名稱",
            awardDate: "頒發日期",
            teachingExperience: "教學年資",
            teachingExperienceOption: {
                five: "五年",
                ten: "六至十年",
                fifteen: "十一至十五年",
                overFifteen: "十五年以上",
            },
            curSchoolOrOrganisation: "在現職學校/機構的職位",
            curSchoolOrOrganisationOption: {
                schoolPost: "學校",
                organisationPost: "機構",
            },
            schoolPost: "在現職學校的職位",
            organisationPost: "在現職機構的職位",
            completeDate: "擬任校長專業發展需要分析完成日期",
            commencementDate: "擬任校長課程開課日期",
            courseAwardDate: "擬任校長課程頒發日期",
            isDeclarationTitle: "聲明",
            declarationP1: "謹此聲明，",
            // declarationContentList: [
            //     "本人已閱讀及明白載於附件甲的「擬任校長專業發展資料冊指引」；",
            //     "本人在申請表填寫的個人資料，以及就本次申請呈交的專業發展資料冊當中的所有事實資料，均屬真實準確；",
            //     "本專業發展資料冊中所提及的行動研究計劃，是本人於就讀「擬任校長課程」時進行； 以及",
            //     "本專業發展資料冊的內容，除引用其他來源資料的部分以外，全屬本人作品，而所引用的其他來源資料，其出處已妥為註明，所抄錄的部分亦以引文方式標示；本專業發展資料冊符合版權法例#。",
            // ],
            declarationP2:
                "本人已閱讀及明白載於附件甲的「擬任校長專業發展資料冊指引」；",
            declarationP3:
                "本人在申請表填寫的個人資料，以及就本次申請呈交的專業發展資料冊當中的所有事實資料，均屬真實準確；",
            declarationP4:
                "本專業發展資料冊中所提及的行動研究計劃，是本人於就讀「擬任校長課程」時進行； 以及",
            declarationP5:
                "本專業發展資料冊的內容，除引用其他來源資料的部分以外，全屬本人作品，而所引用的其他來源資料，其出處已妥為註明，所抄錄的部分亦以引文方式標示；本專業發展資料冊符合版權法例",
            //     "本專業發展資料冊的內容，除引用其他來源資料的部分以外，全屬本人作品，而所引用的其他來源資料，其出處已妥為註明，所抄錄的部分亦以引文方式標示；本專業發展資料冊符合版權法例#。",
            // ],
            attachment: "附件",
            completedByEDB: "此欄由教育局填寫",
        },

        annotation: {
            hash: "請注意，如你的專業發展資料冊未能符合版權法例，你的校長資格認證申請可因此被拒。在此情況下，教育局在你最近一次提交申請的日期起計的一年內，不會接受你重新提交的校長資格認證申請；如情況嚴重，則後果可能更為嚴峻（如檢討你的教師註冊狀況）。",
        },

        errorMsg: {
            nameOfApplicationEn: "申請人姓名（英文）",
            nameOfApplicationCh: "申請人姓名（中文）",
            mailingAddress: "通訊地址",
        },
    },

    submittedDialog: {
        note1: "你已成功送出表格。",
        note2: "請將專業發展資料冊（附「行動研究計劃」）一式兩份",
        note3: "連同此申請表",
        note4: "，經由以下方法遞交:",
        // note5: "學校發展資料冊一式兩份",
        note6: "",
        note7: "以專人遞交至香港添馬添美道2號政府總部東翼5樓教育局專業發展及培訓分部〈請在遞交日期最少2個工作天前致電3509 7471登記預約〉；或",
        note8: "以掛號郵件寄交至",
        note9: "香港添馬添美道2號",
        note10: "政府總部東翼5樓",
        note11: "教育局",
        note12: "專業發展及培訓分部",
        note13: "學校領導及專業發展組收",
    },
};

export default Form016TC;
